import React, {useMemo} from 'react';
import {Button, Card, Col, Form} from "react-bootstrap";
import DownloadLink from "../common/DownloadLink";
import {mBStyles} from "../../helpers";
import Fab from '@mui/material/Fab';
import style from './style.module.less'
import {statusKeys as RS} from "../../helpers/projReportHelper";
import {status as PS} from "../../helpers/passport";
const SelectionFab = ({selectedCount,selectedReportsIds,onModalOpen, onBack}) => {

    const manyApprovedOrClosedDisable = () => selectedReportsIds?.length > 1 && selectedReportsIds?.some(el=>[PS.closed].includes(el.status) && [RS.expertsApproved,RS.approved].includes(el.reportStatus))

    const openClose = selectedReportsIds?.every(el=>[RS.expertsApproved,RS.approved].includes(el.reportStatus) && ![PS.onApproveExperts,PS.onApproveHeadSP,PS.onApproveCommittee,PS.onApprovePortf].includes(el.status)) && !manyApprovedOrClosedDisable()
    const openDecision = ((selectedCount === 1 && selectedReportsIds?.every(el=>[RS.onApproveExperts,RS.approved,RS.expertsApproved,RS.expertsDeclined].includes(el.reportStatus)))
        || (selectedCount > 1 && selectedReportsIds?.every(el=>![RS.approved,RS.expertsApproved,RS.expertsDeclined].includes(el.reportStatus))))
        && !manyApprovedOrClosedDisable()
    const isEditClose = useMemo(()=>selectedReportsIds?.length===1 && [PS.closed].includes(selectedReportsIds[0].status),[selectedReportsIds])
    const isEditDecision = useMemo(()=>selectedReportsIds?.length===1 && [RS.expertsApproved,RS.approved].includes(selectedReportsIds[0].reportStatus),[selectedReportsIds])

    const getFirstReport = () => selectedReportsIds?.length===1 && selectedReportsIds[0]
    return (
        <React.Fragment>
            { !!selectedCount &&  <Fab className={style.selectionFab} disableRipple={true} styles={fabStyles} focusVisible={false} variant="extended" size="small" color="primary">
            <Card>
                <Card.Body>
                    <Form.Group className={style.selectionFabGroup} as={Col}>
                        <span>Выбрано: <span>{selectedCount}</span></span>
                        {openDecision &&<Button onClick={()=>onModalOpen('expertDecision',getFirstReport() ,isEditDecision)} variant={'success'}>{isEditDecision ?'Изменить решение':'Внести решение'}</Button>}
                        {openClose && <Button onClick={()=>onModalOpen('closeProj',getFirstReport(),isEditClose)}variant={'danger'}>{isEditClose ?'Изменить закрытие':'Закрыть проекты'}</Button>}
                        <Button onClick={onBack} variant={'outline-secondary'}>Отмена</Button>
                    </Form.Group>
                </Card.Body>
            </Card>

        </Fab>}
        </React.Fragment>
    );
};

const fabStyles = {
    float:'right',
    left:'30px',
    display:'block'
}

export default SelectionFab;
